import { render, staticRenderFns } from "./hurdle-rates.vue?vue&type=template&id=54176ecc"
import script from "./hurdle-rates.ts?vue&type=script&lang=ts&external"
export * from "./hurdle-rates.ts?vue&type=script&lang=ts&external"
import style0 from "./hurdle-rates.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54176ecc')) {
      api.createRecord('54176ecc', component.options)
    } else {
      api.reload('54176ecc', component.options)
    }
    module.hot.accept("./hurdle-rates.vue?vue&type=template&id=54176ecc", function () {
      api.rerender('54176ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rates-dashboard/hurdle-rates/hurdle-rates.vue"
export default component.exports